var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-group"},_vm._l((_vm.sites),function(site){return _c('AppButton',{key:site.id,staticClass:"st-custom-button",attrs:{"data-network":site.id,"data-url":_vm.url}},[_vm._v(" "+_vm._s(site.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }